/**
 * GameTile — Featured (large) or Coming-soon placeholder card.
 */
import { Users } from "lucide-react";
import { Badge } from "./Badge";
import NewBadge from "../NewBadge";

export function FeaturedGameTile({ image, title, subtitle, playersOnline, onPlay, testid = "featured-game", isNew = false }) {
  return (
    <div
      className="relative overflow-hidden rounded-2xl border border-line bg-elevated group cursor-pointer hover:border-pink hover:shadow-glow-pink transition-all duration-300"
      onClick={onPlay}
      data-testid={testid}
    >
      <div className="aspect-[3/4] w-full">
        <img src={image} alt={title} className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-base via-base/50 to-transparent" />

      {/* NEW badge — top-left overlay, admin-toggled per game. Sits
          left of the Live/HOT cluster which lives at top-right on
          this tile (top-left cluster is empty by default). */}
      {isNew && (
        <div className="absolute top-3 left-3 z-10">
          <NewBadge testid={`${testid}-new-badge`} />
        </div>
      )}

      <div className="absolute top-3 right-3 flex items-center gap-2">
        <Badge variant="live">Live</Badge>
        <Badge variant="hot">HOT</Badge>
      </div>

      <div className="absolute bottom-0 left-0 right-0 p-5">
        <div className="text-[10px] tracking-[0.3em] uppercase text-pink mb-1">Featured game</div>
        <div className="font-display italic text-3xl text-ink mb-1">{title}</div>
        <div className="text-xs text-ink-2 mb-4">{subtitle}</div>
        <div className="flex items-center justify-between">
          <button
            onClick={(e) => { e.stopPropagation(); onPlay?.(); }}
            className="px-6 py-3 rounded-lg bg-brand-gradient text-white font-semibold text-sm shadow-glow-pink hover:brightness-110 hover:scale-[1.03] transition"
            data-testid={`${testid}-play`}
          >
            PLAY NOW
          </button>
          <div className="flex items-center gap-1.5 text-xs text-ink-2">
            <Users className="w-3 h-3 text-success" />
            <span data-testid={`${testid}-players`}>{playersOnline} online</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ComingSoonTile({ image, title, testid }) {
  return (
    <div className="relative overflow-hidden rounded-xl border border-line bg-elevated group" data-testid={testid}>
      <div className="aspect-[3/4] w-full">
        <img src={image} alt={title} className="w-full h-full object-cover opacity-70 group-hover:opacity-90 transition" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-base to-transparent" />
      <div className="absolute top-3 right-3">
        <Badge variant="new">Soon</Badge>
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-3 text-center">
        <div className="font-display italic text-base text-ink truncate">{title}</div>
        <div className="text-[9px] tracking-widest uppercase text-ink-3 mt-0.5">Coming soon</div>
      </div>
    </div>
  );
}
